import { readCookie } from '../../components/common/Cookie';
import { addCustomerType } from '../../utils/products';
import { storeNames } from '../constants/cart.constants';
import { catalogIdToStoreName } from '../../utils/catalogIdToStoreName';

export const proceedToShipping = (cb: (arg0: string) => void): void => {
  const user = readCookie('U');
  if (user === 'anonymous') {
    sessionStorage.setItem('prevUrl', document.referrer);
    cb('/login?referrer=/cart');
  } else {
    cb('/shipping');
  }
};

export const redirect = (url = '') => (): void => {
  window.location.href = url;
};

export const getCartUrl = (): string => {
  return addCustomerType('/cart');
};

export const getDeliveryFeeTagInfo = (
  catalogName: string | undefined,
  storeWiseDeliveryFeeTags: {
    street?: Record<string, string>;
    ajiodeliveryfee?: Record<string, string>;
    ajiofreedelivery?: Record<string, string>;
    luxedeliveryfee?: Record<string, string>;
    luxefreedelivery?: Record<string, string>;
  },
  convenienceFee: { delivery: { netAmount: { value: string } } }
) => {
  const {
    street = {},
    ajiodeliveryfee = {},
    ajiofreedelivery = {},
    luxedeliveryfee = {},
    luxefreedelivery = {}
  } = storeWiseDeliveryFeeTags;
  const itemStoreName = catalogIdToStoreName(catalogName);
  const { AJIO_STORE, LUXE_STORE, STREET_STORE } = storeNames;
  const isDeliveryFeeApplicable = parseInt(convenienceFee?.delivery?.netAmount?.value) > 0;

  let deliveryFeeTag = '';
  let isItemWithFreeDelivery = false;
  if (itemStoreName == STREET_STORE) {
    deliveryFeeTag = street.flag == 'ON' ? street.title : '';
    isItemWithFreeDelivery = true;
  } else if (itemStoreName == AJIO_STORE) {
    deliveryFeeTag = isDeliveryFeeApplicable
      ? ajiodeliveryfee.flag == 'ON'
        ? ajiodeliveryfee.title
        : ''
      : ajiofreedelivery.flag == 'ON'
      ? ajiofreedelivery.title
      : '';
    isItemWithFreeDelivery = !isDeliveryFeeApplicable;
  } else if (itemStoreName == LUXE_STORE) {
    deliveryFeeTag = isDeliveryFeeApplicable
      ? luxedeliveryfee.flag == 'ON'
        ? luxedeliveryfee.title
        : ''
      : luxefreedelivery.flag == 'ON'
      ? luxefreedelivery.title
      : '';
    isItemWithFreeDelivery = !isDeliveryFeeApplicable;
  }

  return { deliveryFeeTag, isItemWithFreeDelivery };
};
